var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 5.33333H9.33268V4C9.33268 2.16 7.83935 0.666668 5.99935 0.666668C4.15935 0.666668 2.66602 2.16 2.66602 4V5.33333H1.99935C1.26602 5.33333 0.666016 5.93333 0.666016 6.66667V13.3333C0.666016 14.0667 1.26602 14.6667 1.99935 14.6667H9.99935C10.7327 14.6667 11.3327 14.0667 11.3327 13.3333V6.66667C11.3327 5.93333 10.7327 5.33333 9.99935 5.33333ZM5.99935 11.3333C5.26602 11.3333 4.66602 10.7333 4.66602 10C4.66602 9.26667 5.26602 8.66667 5.99935 8.66667C6.73268 8.66667 7.33268 9.26667 7.33268 10C7.33268 10.7333 6.73268 11.3333 5.99935 11.3333ZM8.06602 5.33333H3.93268V4C3.93268 2.86 4.85935 1.93333 5.99935 1.93333C7.13935 1.93333 8.06602 2.86 8.06602 4V5.33333Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b8d88bb7.svg";
export { ForwardRef as ReactComponent };